import { memo } from 'react'
import styles from './index.module.scss'

const CIRCUMFERENCE = 100.53 // 2 * PI * 16

const Loader = ({ className, progress, pulse, size = 20, ...props }) => {
	const hasProgress = progress !== undefined && progress !== null
	const dasharray = hasProgress
		? `${progress * CIRCUMFERENCE} ${CIRCUMFERENCE}`
		: `${CIRCUMFERENCE / 3} ${(CIRCUMFERENCE * 2) / 3}`

	return (
		<div className={`${styles.cont} ${className || ''}`} {...props} data-loader>
			<span className={styles.spinner}>
				<svg
					className={`${hasProgress ? styles.has_progress : ''} ${pulse ? styles.pulse : ''}`}
					viewBox='0 0 36 36'
					width={size}
					height={size}
				>
					<circle className={styles.track} cx='18' cy='18' r='16' />
					<circle
						className={styles.ring}
						cx='18'
						cy='18'
						r='16'
						strokeDasharray={dasharray}
						strokeLinecap='round'
						transform='rotate(-90 18 18)'
					/>
				</svg>
			</span>
		</div>
	)
}

export default memo(Loader)
